<template>
  <div class="report-saved-filter-list--container">
    <h6>Saved filters</h6>

    <AppInputSearch>
      <AppInput
        v-model="search"
        type="search"
        placeholder="Search saved filters"
        :debounce="false"
      />
    </AppInputSearch>
    <AppSelectList
      v-if="matchingSavedReportFilters.length > 0"
      class="report-saved-filter-list"
    >
      <AppSelectListItem
        v-for="savedReportFilter in matchingSavedReportFilters"
        :key="savedReportFilter.id"
        class="report-saved-filter-list--item"
        :title="savedReportFilter.description"
        @click="applySavedReportFilter(savedReportFilter)"
      >
        <template #label>
          <span>
            <div class="text-overflow">
              <i class="hi hi-bars hi-16 text-lighter"></i>
              {{ savedReportFilter.name }}
            </div>
          </span>
        </template>

        <template #actions>
          <div
            v-if="showActions"
            class="action-buttons"
          >
            <a
              class="btn btn-transparent btn-icon btn-xxs report-saved-filter-list--edit"
              @click.stop="editSavedReportFilter(savedReportFilter)"
            >
              <i class="hi hi-12 hi-edit-xs"></i>
            </a>
            <a
              class="btn btn-transparent btn-icon btn-xxs report-saved-filter-list--delete ml-10"
              @click.stop="deleteSavedReportFilter(savedReportFilter)"
            >
              <i class="hi hi-12 hi-delete-xs"></i>
            </a>
          </div>
        </template>
      </AppSelectListItem>
    </AppSelectList>
    <p
      v-else
      class="text-grey"
    >
      No saved filters
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { escapeRegExp } from 'lodash-es';

const ERROR_MESSAGE = 'Oops, something went wrong';

export default {
  name: 'ReportSavedReportFilterList',
  props: {
    showActions: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      search: null,
    };
  },
  computed: {
    ...mapGetters({
      savedReportFilters: 'savedReportFiltersByName',
    }),
    matchingSavedReportFilters() {
      if (this.search && this.search.length > 0) {
        return this.savedReportFilters.filter((savedReportFilter) => {
          const pattern = new RegExp(escapeRegExp(this.search), 'i');

          return savedReportFilter.name.search(pattern) > -1;
        });
      }

      return this.savedReportFilters;
    },
  },
  methods: {
    applySavedReportFilter(savedReportFilter) {
      this.$store.dispatch('applySavedReportFilter', savedReportFilter);
    },
    editSavedReportFilter(savedReportFilter) {
      this.$emit('edit', savedReportFilter);
    },
    deleteSavedReportFilter(savedReportFilter) {
      if (confirm('Are you sure?')) {
        const success = () => {
          this.$appMessage(`"${savedReportFilter.name}" has been deleted`);
        };
        const error = () => {
          this.$appMessage(ERROR_MESSAGE);
        };

        this.$store.dispatch('deleteSavedReportFilter', savedReportFilter).then(success, error);
      }
    },
  },
};
</script>
